module.exports = __webpack_public_path__ + "img/Icon_Globe.0a0ad20d.svg";